<template>
	<div class="outer-wrapper">
		<div class="wrapper">

			<transition>
				<overlay-nav v-if="showOverlayNav" />
			</transition>

			<div v-if="this.isHome" style="width:100%; padding:3px 48px; text-align:center; background:#fdb913; color:black; font-family:proxima-nova,sans-serif; font-size:16px;">StudySync is now part of the Imagine Learning family. <a href="https://www.imaginelearning.com/press/studysync-2027-edition-launches-as-part-of-imagine-learnings-full-ela-suite/" target="_blank" style="color:black!important; text-decoration:none!important;"> <strong>Learn more <span>&#10142;</span></strong></a></div>
			<appHeader />

			<router-view :key="$route.path" />

			<transition name="fade">
				<VideoModal v-if="$store.state.app.activeVideoModal" />
			</transition>

		</div>
	</div>
</template>

<script>
	import appHeader from '@/components/AppHeader'
	import OverlayNav from "@/components/OverlayNav"
	import VideoModal from "@/components/VideoModal"

	export default {
		name: 'app',
		metaInfo () {
			const metaInfo = {
				meta: []
			}
			if(this.$route.query.statusCode) {
				metaInfo.meta.push({ name: 'prerender-status-code', content: this.$route.query.statusCode })
			}
			return metaInfo
		},
		components: { appHeader, OverlayNav, VideoModal },
		created () {
			const embedMode = (this.$queryString.embed === '1')
			this.$store.state.app.embedMode = embedMode
			if(embedMode) {
				const $body = document.querySelector('body')
				$body.classList.add('embed-mode')
			}
		},
		computed: {
			showOverlayNav () {
				return this.$store.state.app.overlayNavActive
			},
			isHome() {
				return this.$route.path === '/'
			}
		}
	}
</script>

<style lang="scss" scoped>

	@import "fade-transition";
	@include fade-transition(.3s);

	.wrapper {
		position:relative;
	}

</style>



// WEBPACK FOOTER //
// src/App.vue